/* Lightbox for the customer photo wall (snippets/ft-gang-grid.liquid).
 *
 * Tiles are <button data-ft-gang-open> carrying the full-size URL, the alt
 * text, and optionally a product link. The overlay is built once, lazily, on
 * the first click - a gallery that is never opened costs nothing but this file.
 *
 * Delegated from document, so photos added by a section re-render in the theme
 * editor work without re-binding.
 */
(function () {
  'use strict';
  if (window.__ftGangLightbox) return;
  window.__ftGangLightbox = true;

  var overlay = null;
  var img = null;
  var link = null;
  var lastFocus = null;
  var tiles = [];
  var index = -1;

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'ft-gang-lb';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.hidden = true;
    overlay.innerHTML =
      '<button class="ft-gang-lb-close" type="button" aria-label="Close">&times;</button>' +
      '<button class="ft-gang-lb-nav ft-gang-lb-prev" type="button" aria-label="Previous photo">&#8249;</button>' +
      '<figure class="ft-gang-lb-figure"><img alt=""><a class="ft-gang-lb-shop" href="#"></a></figure>' +
      '<button class="ft-gang-lb-nav ft-gang-lb-next" type="button" aria-label="Next photo">&#8250;</button>';

    img = overlay.querySelector('img');
    link = overlay.querySelector('.ft-gang-lb-shop');

    overlay.querySelector('.ft-gang-lb-close').addEventListener('click', close);
    overlay.querySelector('.ft-gang-lb-prev').addEventListener('click', function (e) {
      e.stopPropagation();
      step(-1);
    });
    overlay.querySelector('.ft-gang-lb-next').addEventListener('click', function (e) {
      e.stopPropagation();
      step(1);
    });
    // Clicking the backdrop closes; clicking the photo or the shop link does not.
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.tagName === 'FIGURE') close();
    });
    document.body.appendChild(overlay);
  }

  function show(i) {
    var tile = tiles[i];
    if (!tile) return;
    index = i;
    img.src = tile.getAttribute('data-full');
    img.alt = tile.getAttribute('data-alt') || '';

    var href = tile.getAttribute('data-href');
    if (href) {
      link.href = href;
      link.textContent = tile.getAttribute('data-label') || 'Shop this';
      link.hidden = false;
    } else {
      link.hidden = true;
    }

    var many = tiles.length > 1;
    overlay.querySelector('.ft-gang-lb-prev').hidden = !many;
    overlay.querySelector('.ft-gang-lb-next').hidden = !many;
  }

  function step(delta) {
    if (!tiles.length) return;
    show((index + delta + tiles.length) % tiles.length);
  }

  function open(tile) {
    if (!overlay) build();
    // Arrow keys walk the grid the photo was clicked in, not the whole page.
    var grid = tile.closest('.ft-gang-grid');
    tiles = Array.prototype.slice.call(
      (grid || document).querySelectorAll('[data-ft-gang-open]')
    );
    lastFocus = tile;
    overlay.hidden = false;
    document.documentElement.classList.add('ft-gang-lb-open');
    show(tiles.indexOf(tile));
    overlay.querySelector('.ft-gang-lb-close').focus();
  }

  function close() {
    if (!overlay || overlay.hidden) return;
    overlay.hidden = true;
    document.documentElement.classList.remove('ft-gang-lb-open');
    img.removeAttribute('src');
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var tile = e.target.closest('[data-ft-gang-open]');
    if (tile) {
      e.preventDefault();
      open(tile);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!overlay || overlay.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') step(-1);
    else if (e.key === 'ArrowRight') step(1);
  });
})();
